export default __webpack_public_path__ + "static/media/2.fc42e1fd.JPG";